import React from 'react';
import cx from 'classnames';

const WhiteContainer = ({ children, ...props }) => {
  const { classes } = props;
  return <div className={cx(classes?.container, classes?.whitePage)}>{children}</div>;
};

export default WhiteContainer;
